import { useParams } from "react-router-dom"
import CustomerInformation from "../components/customer/CustomerInformation"
import { Section, SectionRoot } from "@hydrologiq/shared/chakra/custom/Section"
import UsageInline from "../components/usage/UsageInline"
import { Alert, Skeleton, Tabs } from "@chakra-ui/react"
import CustomerAdmin from "../components/customer/CustomerAdmin"
import { useGetFeature } from "@hydrologiq/shared/providers/helpers/useFeature"
import { useCustomer, useCustomerError, useCustomerLoading } from "../providers/helpers/useCustomer"
import CustomerFigures from "../components/customer/CustomerFigures"
import CustomerSites from "../components/sites/CustomerSites"
import AssetsTable from "@hydrologiq/shared/asset/AssetsTable"

const Customer = () => {
  const { customerId = "" } = useParams()
  const customer = useCustomer()
  const loading = useCustomerLoading()
  const error = useCustomerError()
  const customerAdvancedFeatureEnabled = useGetFeature("customer_advanced")
  // Show loading only if we don't have customer data and query is loading
  if (loading && !customer) {
    return (
      <Skeleton height="100%" width="100%" />
    )
  }

  // Show error if query failed and we don't have store data
  if (error && !customer) {
    return (
      <SectionRoot>
        <Section>
          <Alert.Root status="error">
            <Alert.Indicator />
            <Alert.Title>Failed to load customer</Alert.Title>
            <Alert.Description>{error}</Alert.Description>
          </Alert.Root>
        </Section>
      </SectionRoot>
    )
  }

  return (
    <SectionRoot>
      <Section>
        <CustomerFigures customer={customer ?? undefined} loading={loading} error={error ?? undefined} />
      </Section>

      <Tabs.Root defaultValue="sites" variant={"sectionLozenge" as any}>
        <Tabs.List>
          <Tabs.Trigger value="sites">Sites</Tabs.Trigger>
          <Tabs.Trigger value="assets">Assets</Tabs.Trigger>
          <Tabs.Trigger value="information">Information</Tabs.Trigger>
          {customerAdvancedFeatureEnabled && <Tabs.Trigger value="usage">Usage</Tabs.Trigger>}
          <Tabs.Trigger value="admin">Admin</Tabs.Trigger>
        </Tabs.List>

        <Tabs.Content value="information" style={{ borderTopLeftRadius: 0 }}>
          <CustomerInformation customer={customer} />
        </Tabs.Content>

        <Tabs.Content value="sites">
          <CustomerSites />
        </Tabs.Content>

        <Tabs.Content value="assets">
          <AssetsTable customerId={customerId} external={true} />
        </Tabs.Content>

        {customerAdvancedFeatureEnabled && (
          <Tabs.Content value="usage">
            <UsageInline customer={customer ?? undefined} />
          </Tabs.Content>
        )}

        <Tabs.Content value="admin">
          <CustomerAdmin customer={customer} />
        </Tabs.Content>
      </Tabs.Root>
    </SectionRoot>
  )
}

export default Customer
